/* Anirveda home page (Foxtale clone): hero slider (swipe, dots, auto-advance). Card "Add" buttons are handled by ani-fx.js. */
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function initHero(hero) {
  if (hero.dataset.ready) return;
  hero.dataset.ready = '1';
  const track = hero.querySelector('.ani-fxh-hero__track');
  const all = Array.from(hero.querySelectorAll('.ani-fxh-hero__slide'));
  const dotsWrap = hero.querySelector('.ani-fxh-hero__dots');
  let i = 0;
  let timer;
  const visible = () => all.filter((s) => s.offsetParent !== null || getComputedStyle(s).display !== 'none');
  const render = () => {
    const slides = visible();
    if (!slides.length) return;
    i = ((i % slides.length) + slides.length) % slides.length;
    track.style.transform = `translateX(${-100 * i}%)`;
    if (dotsWrap) {
      dotsWrap.innerHTML = slides.length > 1 ? slides.map((_, j) => `<span class="ani-fxh-hero__dot" aria-current="${j === i}"></span>`).join('') : '';
    }
  };
  const play = () => {
    clearInterval(timer);
    const every = Number(hero.dataset.speed || 5) * 1000;
    if (!reduceMotion && hero.dataset.autoplay === 'true') timer = setInterval(() => { i += 1; render(); }, every);
  };
  let startX = null;
  track.addEventListener('pointerdown', (e) => { startX = e.clientX; });
  track.addEventListener('pointerup', (e) => {
    if (startX === null) return;
    const dx = e.clientX - startX;
    startX = null;
    if (Math.abs(dx) > 40) { i += dx < 0 ? 1 : -1; render(); play(); }
  });
  track.addEventListener('click', (e) => { if (track.dataset.dragged) e.preventDefault(); }, true);
  window.addEventListener('resize', render);
  render();
  play();
}

/* Reels: muted videos play only while at least half on screen (and never with reduced motion) */
const reelObserver = 'IntersectionObserver' in window && !reduceMotion
  ? new IntersectionObserver((entries) => entries.forEach((e) => {
    if (e.isIntersecting) e.target.play().catch(() => {});
    else e.target.pause();
  }), { threshold: 0.5 })
  : null;

function init(root = document) {
  root.querySelectorAll('.ani-fxh-hero').forEach(initHero);
  if (reelObserver) root.querySelectorAll('.ani-fxh-reels__video').forEach((v) => reelObserver.observe(v));
}
init();
document.addEventListener('shopify:section:load', (e) => init(e.target));
